import { useEffect } from "react";
import { Lock } from "lucide-react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { MobileActionBar } from "@/components/MobileActionBar";
import { ClientUploadForm } from "@/components/ClientUploadForm";

const useNoIndex = (title) => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    return () => {
      document.title = prevTitle;
      meta.remove();
    };
  }, [title]);
};

export default function ClientUploadPage() {
  useNoIndex("Client document upload | NUA Private Wealth");

  return (
    <>
      <Header />
      <main>
        <section data-testid="client-upload-section" className="bg-[#0A2333] pt-16 md:pt-[88px]">
          <div className="mx-auto max-w-7xl px-6 md:px-10 py-16 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-14 md:gap-16">
            <div className="md:col-span-5">
              <img src="/assets/nua-mark-transparent.png" alt="" aria-hidden="true" className="h-10 md:h-12 w-auto opacity-90" />
              <p className="mt-8 flex items-center gap-3 text-xs uppercase tracking-[0.25em] text-white">
                <span className="h-px w-10 bg-[#F9F8F4]/50" aria-hidden="true" />
                Existing clients
              </p>
              <h1 data-testid="client-upload-heading" className="mt-6 font-serif text-4xl md:text-5xl tracking-tight text-[#F9F8F4]">
                Send us your documents.
              </h1>
              <p className="mt-6 text-base leading-relaxed text-white max-w-md">
                Upload statements, tax returns or any paperwork Kevin has asked for. Your documents go
                straight to Kevin, and you'll get an email to confirm they've arrived.
              </p>
              <p className="mt-10 flex items-start gap-3 text-sm text-white max-w-md">
                <Lock size={16} className="mt-0.5 shrink-0 text-[#A78558]" />
                <span data-testid="client-upload-security-note">Files are sent securely over HTTPS and encrypted (AES 256).</span>
              </p>
            </div>
            <div className="md:col-span-7">
              <ClientUploadForm />
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <MobileActionBar />
    </>
  );
}
